/*
 * -----------------------------------------------------------------------
 * 2025.6.12---product-des-position-nab---JS
 * -----------------------------------------------------------------------
 */
document.addEventListener("DOMContentLoaded", function () {
  // 检查组件是否存在（避免在非产品页执行）
  const productDesPositionNav = document.querySelector(
    ".product-des-position-nav"
  );
  if (!productDesPositionNav) return;

  // 初始化变量（作用域仅限当前闭包）
  const stickyTop = 0;
  const navHeight = productDesPositionNav.offsetHeight;
  const pcNavItems = document.querySelectorAll(".pc-nav .nav-item");
  const mobileNavDetails = document.getElementById("mobile-nav-details");
  const mobileCurrentSection = document.querySelector(".current-section");
  const mobileNavOptions = document.querySelectorAll(
    ".mobile-nav-options .nav-item"
  );

  // 通用：获取当前激活的模块ID
  function getCurrentActiveId() {
    const scrollY = window.scrollY + navHeight;
    let currentId = null;

    mobileNavOptions.forEach((option) => {
      const targetId = option.getAttribute("href").replace("#", "");
      const target = document.getElementById(targetId);
      if (!target) return;

      const targetTop = target.offsetTop;
      const targetBottom = targetTop + target.offsetHeight;
      if (scrollY >= targetTop && scrollY < targetBottom) {
        currentId = targetId;
      }
    });
    return currentId;
  }

  // 同步更新所有导航的active状态
  function updateActiveState() {
    const currentId = getCurrentActiveId();

    // 更新PC端导航active
    pcNavItems.forEach((item) => {
      const link = item.querySelector("a");
      const targetId = link.getAttribute("href").replace("#", "");
      item.classList.toggle("active", targetId === currentId);
    });

    // 更新移动端导航显示
    if (currentId) {
      const activeOption = [...mobileNavOptions].find(
        (opt) => opt.getAttribute("href") === `#${currentId}`
      );
      if (activeOption)
        mobileCurrentSection.textContent = activeOption.textContent;
    }
  }

  // 滚动处理函数（整合吸顶+active更新）
  function handleScroll() {
    // 吸顶状态
    const isSticky =
      productDesPositionNav.getBoundingClientRect().top <= stickyTop;
    productDesPositionNav.classList.toggle("product-nav-sticky", isSticky);

    // 实时更新active状态
    updateActiveState();
  }

  // 移动端选项点击处理（平滑滚动）
  mobileNavOptions.forEach((option) => {
    option.addEventListener("click", (e) => {
      e.preventDefault();
      const targetId = option.getAttribute("href");
      const target = document.querySelector(targetId);

      if (target) {
        const targetTop =
          target.getBoundingClientRect().top + window.scrollY - navHeight;
        window.scrollTo({ top: targetTop, behavior: "smooth" });
        mobileNavDetails.removeAttribute("open");
      }
    });
  });

  // 点击外部关闭下拉菜单
  document.addEventListener("click", (e) => {
    if (!mobileNavDetails) return;
    const isClickInside = mobileNavDetails.contains(e.target);
    if (!isClickInside && mobileNavDetails.hasAttribute("open")) {
      mobileNavDetails.removeAttribute("open");
    }
  });

  // 绑定事件（添加防抖）
  let scrollTimeout;
  window.addEventListener("scroll", () => {
    if (scrollTimeout) clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(handleScroll, 30);
  });
  window.addEventListener("resize", handleScroll);
  handleScroll(); // 初始加载执行一次
});

/*
 * -----------------------------------------------------------------------
 * 2025.4.7---guarantee-container---JS
 * -----------------------------------------------------------------------
 */
document.addEventListener("DOMContentLoaded", function () {
  var cards = [];
  var selectors = [
    ".card1",
    ".card2",
    ".card3",
    ".card4",
    ".card5",
    ".card6",
    ".card7",
  ];
  selectors.forEach(function (sel) {
    var el = document.querySelector(sel);
    if (el) cards.push(el);
  });

  function startNumberAnimation() {
    var numberElements = document.querySelectorAll(".card1-des-info-title");
    numberElements.forEach(function (el, index) {
      var finalValue = index === 0 ? "50" : "3";
      var interval = setInterval(function () {
        var rand = Math.floor(Math.random() * 100);
        el.innerText = rand;
      }, 50);
      setTimeout(function () {
        clearInterval(interval);
        el.innerText = finalValue;
      }, 3000);
    });
  }

  var container = document.querySelector(".guarantee-container");
  var observer = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          cards.forEach(function (card, index) {
            setTimeout(function () {
              card.classList.add("animate");
            }, index * 100);
          });
          startNumberAnimation();
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2 }
  );

  if (container) observer.observe(container);
});

/*
 * -----------------------------------------------------------------------
 * 2025.3.17---hiboost-region-selector---JS
 * -----------------------------------------------------------------------
 */
(function () {
  const SELECTOR = ".hiboost-region-selector";
  let activeDropdown = null;

  // 初始化单个组件
  function initRegionSelector(element) {
    const summary = element.querySelector("summary");
    if (!summary) return;

    const isTouchDevice =
      "ontouchstart" in window || navigator.maxTouchPoints > 0;

    // 统一关闭方法
    const closeDropdown = () => {
      element.removeAttribute("open");
      activeDropdown = null;
    };

    // 桌面端 hover 逻辑
    if (!isTouchDevice) {
      let hoverTimer;

      summary.addEventListener("mouseenter", () => {
        clearTimeout(hoverTimer);
        element.setAttribute("open", "");
        activeDropdown = element;
      });

      element.addEventListener("mouseleave", () => {
        hoverTimer = setTimeout(closeDropdown, 300);
      });

      element.addEventListener("mouseenter", () => {
        clearTimeout(hoverTimer);
      });
    }

    // 移动端点击逻辑
    if (isTouchDevice) {
      summary.addEventListener("click", (e) => {
        e.preventDefault();
        element.toggleAttribute("open");
        activeDropdown = element.open ? element : null;
      });
    }

    // 全局点击关闭
    document.addEventListener("click", (e) => {
      if (activeDropdown && !activeDropdown.contains(e.target)) {
        closeDropdown();
      }
    });

    // 窗口失焦关闭
    window.addEventListener("blur", closeDropdown);
  }

  // 自动初始化现有实例
  document.querySelectorAll(SELECTOR).forEach(initRegionSelector);

  // 动态加载监听
  new MutationObserver((mutations) => {
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.matches(SELECTOR)) {
          initRegionSelector(node);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();

/*
 * -----------------------------------------------------------------------
 * 2024.12.31--- 产品描述的规格模块Tech Specs折叠效果JS
 * -----------------------------------------------------------------------
 */
function toggleCollapse(button) {
  const content = document.getElementById("tech-specs-list");
  const isExpanded = content.classList.toggle("expanded");

  const buttonText = button.querySelector(".reversed-link");
  const icon = button.querySelector(".circle-chevron");

  if (isExpanded) {
    buttonText.textContent = "View less";
    button.setAttribute("aria-expanded", "true");
  } else {
    buttonText.textContent = "View all";
    button.setAttribute("aria-expanded", "false");

    const target = document.getElementById("tech_specs_for_herf");
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}
window.toggleCollapse = toggleCollapse; // 将函数挂载到全局对象

/*
 * -----------------------------------------------------------------------
 * 2024.12.16---家用产品添加的文字，图片动画效果
 * -----------------------------------------------------------------------
 */
document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".section-box");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 获取所有的 text-animation 元素
          const textElements = entry.target.querySelectorAll(".text-animation");
          const imgElements = entry.target.querySelectorAll(".img-animation");

          // 为每个 text-animation 元素动态添加延迟
          textElements.forEach((el, index) => {
            // 动态计算延迟时间，根据索引进行递增
            el.style.transitionDelay = `${index * 0.05}s`; // 每个元素间隔 0.2s
            el.classList.add("animate");
          });

          // 图片部分的动画，直接显示，不涉及延迟
          imgElements.forEach((el) => el.classList.add("animate"));
        } else {
          // 当元素离开视口时移除动画类
          const bounding = entry.boundingClientRect;
          if (bounding.top > 0) {
            const textElements =
              entry.target.querySelectorAll(".text-animation");
            const imgElements = entry.target.querySelectorAll(".img-animation");

            textElements.forEach((el) => el.classList.remove("animate"));
            imgElements.forEach((el) => el.classList.remove("animate"));
          }
        }
      });
    },
    { threshold: 0.2 } // 超过 20% 可见时触发
  );

  sections.forEach((section) => observer.observe(section));
});

/*
 * -----------------------------------------------------------------------
 * 2024.12.4---产品详情页模拟手机滑动模块的处理js
 * -----------------------------------------------------------------------
 */
let stickyOffsetTop, stickyHeight, phoneHeight, stepSize;
const images = document.querySelectorAll(".phone-content img");
const imageContent = document.getElementById("img-content");
const titles = document.querySelectorAll(".centerImg-title");
let ticking = false;
let lastIndex = -1;

// 实时获取 sticky-box 的位置
function getStickyBoxOffsetTop() {
  const stickyBox = document.getElementById("sticky-box");
  return stickyBox ? stickyBox.getBoundingClientRect().top + window.scrollY : 0;
}

// 初始化滚动相关的尺寸变量
function initializeDimensions() {
  const stickyBox = document.getElementById("sticky-box");
  const phoneModel = document.querySelector(".phone-frame");

  if (!stickyBox || !phoneModel || images.length === 0 || titles.length === 0) {
    return;
  }

  stickyOffsetTop = getStickyBoxOffsetTop();
  stickyHeight = stickyBox.offsetHeight;
  phoneHeight = phoneModel.offsetHeight;
  stepSize = (stickyHeight - phoneHeight) / images.length;

  // 使用 ResizeObserver 动态更新
  const observer = new ResizeObserver(() => {
    stickyOffsetTop = getStickyBoxOffsetTop();
    stickyHeight = stickyBox.offsetHeight;
    stepSize = (stickyHeight - phoneHeight) / images.length;
  });
  observer.observe(stickyBox);
}

// 更新左侧文案内容和过渡效果
function updateImageContent(text) {
  if (!imageContent) return;

  // 移除当前激活状态，触发淡出效果
  imageContent.classList.remove("active");

  // 等待动画完成后更新文本内容，并添加激活状态触发淡入效果
  setTimeout(() => {
    imageContent.textContent = text;
    imageContent.classList.add("active");
  }, 200); // 延时200ms以配合动画过渡
}

// 激活右侧小标题
function activateTitle(index) {
  titles.forEach((title, i) => {
    title.classList.toggle("active", i === index);
  });
}

// 处理滚动事件的逻辑
function handleScrollWithStep() {
  if (!stickyOffsetTop || !stickyHeight || !phoneHeight || !stepSize) return;

  const scrollY = window.scrollY;

  // 实时更新 stickyOffsetTop 避免内容偏移导致逻辑失效
  stickyOffsetTop = getStickyBoxOffsetTop();

  // 判断是否在 sticky-box 范围内
  if (scrollY < stickyOffsetTop || scrollY > stickyOffsetTop + stickyHeight) {
    return;
  }

  const scrollOffset = Math.max(
    0,
    Math.min(scrollY - stickyOffsetTop, stickyHeight - phoneHeight)
  );

  const currentIndex = Math.floor(scrollOffset / stepSize);

  if (currentIndex !== lastIndex) {
    images.forEach((img, index) => {
      img.classList.toggle("active", index === currentIndex);
    });

    const activeImage = images[currentIndex];
    if (activeImage && activeImage.dataset.text) {
      updateImageContent(activeImage.dataset.text);
    }

    activateTitle(currentIndex);
    lastIndex = currentIndex;
  }
}

// 右侧小标题交互功能
function addTitleInteractions() {
  titles.forEach((title, index) => {
    // 鼠标悬停激活
    title.addEventListener("mouseenter", () => {
      images.forEach((img, i) => img.classList.toggle("active", i === index));
      activateTitle(index);
      if (images[index] && images[index].dataset.text) {
        updateImageContent(images[index].dataset.text);
      }

      // 同步更新 lastIndex 确保滚动逻辑正常
      lastIndex = index;
    });
  });
}

// 滚动事件节流
function onScroll() {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      handleScrollWithStep();
      ticking = false;
    });
    ticking = true;
  }
}

// 初始化函数
function initialize() {
  initializeDimensions(); // 初始化滚动相关参数
  addTitleInteractions(); // 添加右侧交互功能
  window.addEventListener("scroll", onScroll); // 绑定滚动事件
  window.addEventListener("resize", initializeDimensions); // 绑定窗口大小变化事件

  // 等待所有资源加载完成后重新触发逻辑
  window.onload = () => {
    initializeDimensions();
    if (
      window.scrollY >= stickyOffsetTop &&
      window.scrollY <= stickyOffsetTop + stickyHeight
    ) {
      handleScrollWithStep(); // 如果在范围内，重新初始化状态
    }
  };
}

// 等待DOM内容加载完毕后初始化
document.addEventListener("DOMContentLoaded", initialize);

/*
 * -----------------------------------------------------------------------
 * Home page youtube video showing logic code module
 * -----------------------------------------------------------------------
 */
function throttle(callback) {
  let requestId = null,
    lastArgs;
  const later = (context) => () => {
    requestId = null;
    callback.apply(context, lastArgs);
  };
  const throttled = (...args) => {
    lastArgs = args;
    if (requestId === null) {
      requestId = requestAnimationFrame(later(this));
    }
  };
  throttled.cancel = () => {
    cancelAnimationFrame(requestId);
    requestId = null;
  };
  return throttled;
}
function debounce(fn, delay) {
  let timer = null;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

// js/common/behavior/scroll-area.js
var ScrollArea = class {
  constructor(element, abortController2 = null) {
    this._element = element;
    this._allowTriggerNearingStartEvent = false;
    this._allowTriggerLeavingStartEvent = true;
    this._allowTriggerNearingEndEvent = true;
    this._allowTriggerLeavingEndEvent = false;
    new ResizeObserver(this._checkIfScrollable.bind(this)).observe(element);
    this._element.addEventListener(
      "scroll",
      throttle(this._onScroll.bind(this)),
      { signal: abortController2?.signal }
    );
  }
  get scrollNearingThreshold() {
    return 125;
  }
  get scrollDirection() {
    if (this._element.scrollWidth > this._element.clientWidth) {
      return "inline";
    } else if (this._element.scrollHeight - this._element.clientHeight > 1) {
      return "block";
    } else {
      return "none";
    }
  }
  _checkIfScrollable() {
    this._element.classList.toggle(
      "is-scrollable",
      this.scrollDirection !== "none"
    );
  }
  _onScroll() {
    clearTimeout(this._scrollTimeout);
    this._lastScrollPosition =
      this._lastScrollPosition ??
      (this.scrollDirection === "inline"
        ? Math.abs(this._element.scrollLeft)
        : Math.abs(this._element.scrollTop));
    let direction;
    if (this.scrollDirection === "inline") {
      direction =
        this._lastScrollPosition > Math.abs(this._element.scrollLeft)
          ? "start"
          : "end";
      this._lastScrollPosition = Math.abs(this._element.scrollLeft);
    } else {
      direction =
        this._lastScrollPosition > Math.abs(this._element.scrollTop)
          ? "start"
          : "end";
      this._lastScrollPosition = Math.abs(this._element.scrollTop);
    }
    const scrollPosition = Math.round(
        Math.abs(
          this.scrollDirection === "inline"
            ? this._element.scrollLeft
            : this._element.scrollTop
        )
      ),
      scrollMinusSize = Math.round(
        this.scrollDirection === "inline"
          ? this._element.scrollWidth - this._element.clientWidth
          : this._element.scrollHeight - this._element.clientHeight
      );
    if (
      direction === "start" &&
      this._allowTriggerNearingStartEvent &&
      scrollPosition <= this.scrollNearingThreshold
    ) {
      this._allowTriggerNearingStartEvent = false;
      this._allowTriggerLeavingStartEvent = true;
      this._element.dispatchEvent(
        new CustomEvent("scroll:edge-nearing", {
          bubbles: true,
          detail: { position: "start" },
        })
      );
    } else if (
      direction === "end" &&
      scrollPosition > this.scrollNearingThreshold
    ) {
      this._allowTriggerNearingStartEvent = true;
      if (this._allowTriggerLeavingStartEvent) {
        this._allowTriggerLeavingStartEvent = false;
        this._element.dispatchEvent(
          new CustomEvent("scroll:edge-leaving", {
            bubbles: true,
            detail: { position: "start" },
          })
        );
      }
    }
    if (
      direction === "end" &&
      this._allowTriggerNearingEndEvent &&
      scrollMinusSize <= scrollPosition + this.scrollNearingThreshold
    ) {
      this._allowTriggerNearingEndEvent = false;
      this._allowTriggerLeavingEndEvent = true;
      this._element.dispatchEvent(
        new CustomEvent("scroll:edge-nearing", {
          bubbles: true,
          detail: { position: "end" },
        })
      );
    } else if (
      direction === "start" &&
      scrollMinusSize > scrollPosition + this.scrollNearingThreshold
    ) {
      this._allowTriggerNearingEndEvent = true;
      if (this._allowTriggerLeavingEndEvent) {
        this._allowTriggerLeavingEndEvent = false;
        this._element.dispatchEvent(
          new CustomEvent("scroll:edge-leaving", {
            bubbles: true,
            detail: { position: "end" },
          })
        );
      }
    }
    if (window.onscrollend === void 0) {
      this._scrollTimeout = setTimeout(() => {
        this._element.dispatchEvent(
          new CustomEvent("scrollend", { bubbles: true, composed: true })
        );
      }, 75);
    }
  }
};

// js/common/behavior/video-link-blocks.js
var VideoLinkBlocks = class extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.children);
    new ScrollArea(this);

    this.addEventListener("control:prev", this._prev);
    this.addEventListener("control:next", this._next);
  }

  _prev() {
    this.scrollBy({
      left: (document.dir === "rtl" ? 1 : -1) * this.items[0].clientWidth,
      behavior: "smooth",
    });
  }

  _next() {
    this.scrollBy({
      left: (document.dir === "rtl" ? -1 : 1) * this.items[0].clientWidth,
      behavior: "smooth",
    });
  }
};

if (!window.customElements.get("video-link-blocks")) {
  window.customElements.define("video-link-blocks", VideoLinkBlocks);
}

export {
  stickyOffsetTop,
  stickyHeight,
  phoneHeight,
  stepSize,
  images,
  imageContent,
  titles,
  ticking,
  lastIndex,
  initializeDimensions,
  updateImageContent,
  activateTitle,
  handleScrollWithStep,
  addTitleInteractions,
  onScroll,
  initialize,
  throttle,
  debounce,
  ScrollArea,
  VideoLinkBlocks,
};
